// app/utils/renderWithLineBreaks.tsx
"use client";
import * as React from "react";

export function renderWithLineBreaks(text: string | undefined | null) {
  if (!text) return null;
  const parts = text.split(/\n|<br\s*\/?>/gi);
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <br />}
    </React.Fragment>
  ));
}